document.addEventListener("DOMContentLoaded", () => {
  window.addEventListener("cart:refresh", () => {
    refreshCartDisplay();
  });
  window.addEventListener("cart:updated", (event) => {
    var _a, _b;
    const customEvent = event;
    if (((_b = (_a = customEvent.detail) == null ? void 0 : _a.payload) == null ? void 0 : _b.selling_plan) !== void 0) {
      refreshCartDisplay();
    }
  });
  function refreshCartDisplay() {
    const cartContainers = document.querySelectorAll("[data-api-content], .cart__items");
    cartContainers.forEach((container) => {
      refreshCartContainer(container);
    });
  }
  function refreshCartContainer(container) {
    var _a, _b;
    if (!container) return;
    const operationId = `refresh-container-${Date.now()}`;
    if ((_b = (_a = window.Shopify) == null ? void 0 : _a.cart) == null ? void 0 : _b.loadingManager) {
      window.Shopify.cart.loadingManager.startLoading(operationId);
    }
    container.classList.add("is-loading");
    const url = container.matches("[data-api-content]") ? "/cart?section_id=api-cart-items" : "/cart?view=ajax";
    fetch(url).then((response) => {
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      return response.text();
    }).then((html) => {
      if (container.matches("[data-api-content]")) {
        smartUpdateContainer(container, html);
      } else {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, "text/html");
        let newContent = null;
        if (container.matches(".cart__items")) {
          newContent = doc.querySelector(".cart__items");
        }
        if (newContent) {
          smartUpdateContainer(container, newContent.innerHTML);
        } else {
          console.warn("Could not find matching content in cart refresh response");
        }
      }
      initializeCartComponents(container);
      window.dispatchEvent(new CustomEvent("cart:refreshed", {
        detail: {
          container
        }
      }));
    }).catch((error) => {
      console.error("Failed to refresh cart:", error);
    }).finally(() => {
      var _a2, _b2;
      if ((_b2 = (_a2 = window.Shopify) == null ? void 0 : _a2.cart) == null ? void 0 : _b2.loadingManager) {
        window.Shopify.cart.loadingManager.endLoading(operationId);
      }
      container.classList.remove("is-loading");
    });
  }
  function smartUpdateContainer(container, newHtml) {
    const tempContainer = document.createElement("div");
    tempContainer.innerHTML = newHtml;
    const currentElements = Array.from(container.children);
    const newElements = Array.from(tempContainer.children);
    const processedElements = /* @__PURE__ */ new Set();
    currentElements.forEach((currentElement, index) => {
      const currentKey = getElementKey(currentElement);
      const newElement = newElements.find((el) => getElementKey(el) === currentKey);
      if (newElement && !processedElements.has(newElement)) {
        updateElementContent(currentElement, newElement);
        processedElements.add(newElement);
      } else {
        if (!shouldPreserveElement(currentElement)) {
          currentElement.remove();
        }
      }
    });
    newElements.forEach((newElement, index) => {
      if (!processedElements.has(newElement)) {
        const referenceElement = container.children[index];
        if (referenceElement) {
          container.insertBefore(newElement, referenceElement);
        } else {
          container.appendChild(newElement);
        }
      }
    });
  }
  function getElementKey(element) {
    var _a;
    const id = element.getAttribute("id");
    if (id) return `id:${id}`;
    const dataKey = element.getAttribute("data-key") || element.getAttribute("data-line-item-key");
    if (dataKey) return `key:${dataKey}`;
    const variantId = element.getAttribute("data-variant-id");
    if (variantId) return `variant:${variantId}`;
    const classList = Array.from(element.classList).filter((cls) => cls.includes("cart-item") || cls.includes("line-item") || cls.includes("subscription")).sort().join(" ");
    if (classList) return `class:${classList}`;
    const tagName = element.tagName.toLowerCase();
    const contentHash = hashString(((_a = element.textContent) == null ? void 0 : _a.trim()) || "");
    return `${tagName}:${contentHash}`;
  }
  function shouldPreserveElement(element) {
    if (element.hasAttribute("data-collapsible") || element.querySelector("[data-collapsible]") || element.matches("[data-collapsible], .collapsible")) {
      return true;
    }
    if (element.matches(".subscription-dropdown, [data-interactive], .cart-drawer-footer")) {
      return true;
    }
    if (element.hasAttribute("open") || element.matches('[open="true"]')) {
      return true;
    }
    return false;
  }
  function updateElementContent(currentElement, newElement) {
    var _a, _b;
    const stateAttributes = ["open", "aria-expanded", "aria-selected", "data-state"];
    const preservedStates = {};
    stateAttributes.forEach((attr) => {
      if (currentElement.hasAttribute(attr)) {
        preservedStates[attr] = currentElement.getAttribute(attr);
      }
    });
    const currentText = (_a = currentElement.textContent) == null ? void 0 : _a.trim();
    const newText = (_b = newElement.textContent) == null ? void 0 : _b.trim();
    if (currentText !== newText) {
      if (!currentElement.querySelector("[data-collapsible], .subscription-dropdown, [data-interactive]")) {
        currentElement.innerHTML = newElement.innerHTML;
      } else {
        updateSelectiveContent(currentElement, newElement);
      }
    }
    Object.entries(preservedStates).forEach(([attr, value]) => {
      if (value !== null) {
        currentElement.setAttribute(attr, value);
      }
    });
  }
  function updateSelectiveContent(currentElement, newElement) {
    const currentChildren = Array.from(currentElement.childNodes);
    const newChildren = Array.from(newElement.childNodes);
    currentChildren.forEach((child, index) => {
      const newChild = newChildren[index];
      if (child.nodeType === Node.TEXT_NODE && (newChild == null ? void 0 : newChild.nodeType) === Node.TEXT_NODE) {
        if (child.textContent !== newChild.textContent) {
          child.textContent = newChild.textContent;
        }
      } else if (child.nodeType === Node.ELEMENT_NODE && (newChild == null ? void 0 : newChild.nodeType) === Node.ELEMENT_NODE) {
        const currentEl = child;
        const newEl = newChild;
        if (!shouldPreserveElement(currentEl)) {
          if (currentEl.outerHTML !== newEl.outerHTML) {
            currentEl.replaceWith(newEl);
          }
        }
      }
    });
  }
  function hashString(str) {
    let hash = 0;
    if (str.length === 0) return hash;
    for (let i = 0; i < str.length; i++) {
      const char = str.charCodeAt(i);
      hash = (hash << 5) - hash + char;
      hash = hash & hash;
    }
    return hash;
  }
  function initializeCartComponents(container) {
    const quantityInputs = container.querySelectorAll(".cart__quantity-field");
    quantityInputs.forEach((input) => {
      var _a;
      const newInput = input.cloneNode(true);
      (_a = input.parentNode) == null ? void 0 : _a.replaceChild(newInput, input);
    });
    window.dispatchEvent(new CustomEvent("cart:components:initialized", {
      detail: {
        container
      }
    }));
  }
});
